export default __webpack_public_path__ + "static/media/logo.adfc6b47.svg";